import axios from "./axiosConfig";

// Periodic autosave during active answering, deliberately NOT sharing saveToMongoFunction.
// saveToMongoFunction adjusts examDetail[0].webproctoringcount by windowSwitchCount on every
// call - correct when called exactly once per actual tab-switch/violation/unload event, but
// calling it on a fixed timer would re-subtract the same windowSwitchCount repeatedly and
// falsely trip the "too many tab-switches" termination within a couple of minutes. This
// function only persists the current answer snapshot; proctoring bookkeeping stays
// exclusively with the existing event-driven triggers.
const heartbeatSaveFunction = async (examId, examDetail, testData) => {
  const currentStatus = examDetail[0].status;
  if (currentStatus === "010" || currentStatus === "011" || currentStatus === "111" || currentStatus === "113" || currentStatus === "114") {
    return true;
  }

  const remainingTime = window.localStorage.getItem("remainingTime");
  const isValidRemainingTime = remainingTime !== null && remainingTime !== undefined && remainingTime !== "" && !isNaN(Number(remainingTime));
  if (isValidRemainingTime) {
    examDetail[0].time_remaining = Number(remainingTime);
  }
  // If invalid, leave examDetail[0].time_remaining exactly as it already is - a heartbeat
  // must never overwrite a good stored value with a guess. The backend's own fallback
  // chain (last known-good value, then full allotted duration) covers a genuinely missing one.

  const encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(examDetail))));
  const encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(testData))));

  const MAX_ATTEMPTS = 2;
  const BACKOFF_MS = 1000;

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      await axios.post("/test/answeredQuestions", {
        headers: { "Access-Control-Allow-Origin": "*" },
        examDetail: encodedExamDetail,
        id: examDetail[0].id,
        quesData: encodedQuesData,
      });
      console.log(`heartbeat autosave succeeded at ${new Date().toISOString()}${attempt > 1 ? ` (attempt ${attempt})` : ""}`);
      return true;
    } catch (error) {
      const httpStatus = error?.response?.status;
      const isNonRetriable = httpStatus >= 400 && httpStatus < 500;
      console.log(`heartbeat autosave attempt ${attempt}/${MAX_ATTEMPTS} failed (status=${httpStatus || "network"}):`, error?.message || error);
      if (isNonRetriable || attempt === MAX_ATTEMPTS) break;
      await new Promise((resolve) => setTimeout(resolve, BACKOFF_MS));
    }
  }
  return false;
};

export default heartbeatSaveFunction;
